'use strict'

/** Call module on site
 *
 * @module app
 * @alias entry
 * @external lodash/throttle
 * @requires module:common
 * @requires lodash/throttle
 * */

import { throttle } from 'lodash'


/* Import des modules et appel d'initialisation */
import common from './modules/common'

const CLASS_PAGE_RESULTS = 'js-search'
const CLASS_PAGE_CAMPING = 'fiche-camping'
const CLASS_PAGE_CHOOSE_CAMPING = 'choose-camp'
const CLASS_PAGE_TOURISM = 'tourism'

/**
 * On DOM ready, initialize modules which we need
 */
document.addEventListener('DOMContentLoaded', () => {
  const body = document.body

  /**
   * Call init function
   */
  common.init()

  /**
   * Load module results if in search page
   * @requires module:results
   */
  if (body.getElementsByClassName(CLASS_PAGE_RESULTS).item(0) !== null) {
    require.ensure([], function (require) {
      let results = require('./modules/results')
      results.default.init()
    })
  }

  /**
   * Load module article if in article page
   * @requires module:article
   */
  if (body.getElementsByClassName(CLASS_PAGE_CAMPING).item(0) !== null) {
    require.ensure([], function (require) {
      let article = require('./modules/article')
      article.default.init()
    })
  }

  /**
   * Load module chooseCampsite if in chooseCampsite page
   * @requires module:chooseCampsite
   */
  if (body.getElementsByClassName(CLASS_PAGE_CHOOSE_CAMPING).item(0) !== null) {
    require.ensure([], function (require) {
      let chooseCampsite = require('./modules/chooseCampsite')
      chooseCampsite.default.init()
    })
  }


  /**
   * Load module chooseTourism if in chooseTourism page
   * @requires module:chooseTourism
   */
  if (body.getElementsByClassName(CLASS_PAGE_TOURISM).item(0) !== null) {
    require.ensure([], function (require) {
      let chooseTourism = require('./modules/chooseTourism')
      chooseTourism.default.init()
    })
  }

  /**
   * Handler on scroll
   * @listens scroll
   */
  window.addEventListener('scroll', throttle(common.scroll, 100))
})



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/app.js